import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { placePurchaseOrder, PlacePurchaseOrderRequest } from '../common/api/clients/mariapps.api';

export const useMariAppsPlacePurchaseOrder = () => {
    return useMutation<void, AxiosError<{ error?: string }>, PlacePurchaseOrderRequest>({
        mutationFn: placePurchaseOrder,
    });
};
